import React from 'react';
import PropTypes from 'prop-types';
import s from './ReportBreadcrumbs.module.css';
import MLIcon from '../MLIcon';

const ReportBreadcrumbs = (props) => {
  const { items, className } = props;

  const renderBreadcrumbItem = (item, index, lastItem = false) => (
    (lastItem) ?
      // eslint-disable-next-line jsx-a11y/aria-props
      <button key={`bc-item-${index}`} aria-current="page" className={s.breadcrumbText}>
        {item.text || ''}
      </button> :
      <button
        key={`bc-item-${index}`} role="link" className={s.breadcrumbLink}
        onClick={() => {
          props.onTabChange(item.targetUrl);
        }}
      >
        {item.text || ''}
      </button>
  );

  return (
    <nav aria-label="Breadcrumb" className={className ? `${className} ${s.breadcrumbContainer}` : s.breadcrumbContainer}>
      <ol>
        { items.map((item, index) => (
          <li key={`bc-list-item-${index}`}>
            { index > 0 ? <MLIcon className={s.caret} aria-hidden="true" type="caret_right" /> : '' }
            { renderBreadcrumbItem(item, index, (index === (items.length - 1))) }
          </li>
        )) }
      </ol>
    </nav>
  );
};

ReportBreadcrumbs.propTypes = {
  className: PropTypes.string,
  items: PropTypes.array,
  maxLength: PropTypes.number,
  onTabChange: PropTypes.func,
};

ReportBreadcrumbs.defaultProps = {
  items: [],
  maxLength: 70,
};

export default ReportBreadcrumbs;
